import React from 'react';
import { NavLink } from 'react-router-dom';

const MandatesCrumb = () => <NavLink to="/core/mandates">Mandates</NavLink>;

export default MandatesCrumb;
